import clsx from 'clsx'
import Typo from 'constants/typography'

const getClassNameWithOpacity = (checkClass, isSoldOut, isDiamondProduct) =>
  clsx(checkClass, {
    opacity: isSoldOut,
    'diamond-product': isDiamondProduct,
  })

const getPriceClass = (discountValue, isSoldOut, isDiamondProduct) =>
  getClassNameWithOpacity(
    discountValue
      ? clsx(Typo.price2, 'cart-item-info__price-stroke')
      : Typo.price1,
    isSoldOut,
    isDiamondProduct,
  )

const isLowInStock = (isSoldOut, product, selectedAttribute) =>
  !isSoldOut && product.is_available && selectedAttribute.stock.is_low_quantity

const freeGiftPriceClass = (isShoppingBagNewDesign) =>
  isShoppingBagNewDesign
    ? clsx(Typo.price1, 'free-gift__text-red')
    : clsx(Typo.subtitle2, 'free-gift__text')

export {
  getPriceClass,
  isLowInStock,
  freeGiftPriceClass,
  getClassNameWithOpacity,
}
